<script>
  import { onMount } from "svelte";
  import * as PropTypes from "prop-types";
  const { checkPropTypes, func, object, string } = PropTypes;
  import * as css from "@/utils/css";

  export let sortBy, sortText, handleSelectSort, handleCloseSort;

  const propTypes = {
    sortBy: string,
    sortText: object,
    handleSelectSort: func,
    handleCloseSort: func,
  };

  let fullHeight = false;

  const handleClose = (e) => {
    fullHeight = false;
    setTimeout(handleCloseSort, 100);
  };

  const handleSelect = (s) => {
    handleSelectSort(s);
    handleClose();
  };

  onMount(() => {
    checkPropTypes(propTypes, $$props, "prop", "Sort");
    setTimeout(() => {
      fullHeight = true;
    }, 0);
  });
</script>

<div
  on:click|stopPropagation={handleClose}
  class={`${css.fullCover} z-[3] bg-overlay-grey flex items-center justify-end flex-col text-white`}
>
  <div
    on:click|stopPropagation
    class={`${
      fullHeight ? "translate-y-0" : "translate-y-full"
    } w-full overflow-auto bg-black rounded-[15px] cursor-default trs-slider-fast`}
  >
    {#each Object.keys(sortText) as sortOption (sortOption)}
      <div
        on:click={() => handleSelect(sortOption)}
        class={`${sortOption === sortBy ? "font-bold" : ""} ${
          css.allCenteredChild
        }  p-md my-md mx-mmd bg-bg-secondary-moj rounded-lg cursor-pointer`}
      >
        {sortText[sortOption]}
      </div>
    {/each}
    <hr class={css.hr} />
    <div
      on:click={handleClose}
      class={`${css.allCenteredChild} m-md mb-mmd cursor-pointer`}
    >
      Cancel
    </div>
  </div>
</div>
